import Accordion from './accordion/accordion';
import BounceDetection from './bounce-detection/bounce-detection';
import Box from './box/box';
import Breadcrumb from './breadcrumb/breadcrumb';
import Button from './button/button';
import Card from './card/card';
import CarouselCard from './cards/carousel/carousel';
import CTACard from './cards/cta/cta';
import HeadingCard from './cards/heading/heading';
import TileCard from './cards/tile/tile';
import Collection from './collection/collection';
import Container from './container/container';
import ABTestContext, { ABTestContextPossibleTriggers as IABTestContextPossibleTriggers } from './context/ab-test-context';
import LayoutContext, { LayoutContextProps as ILayoutContextProps } from './context/layout-context';
import Form from './form/form/form';
import Heading from './heading/heading';
import Icon from './icon/icon';
import Image from './image/image';
import Link from './link/link';
import linkParser from './link/link-parser';
import StyledGatsbyLink from './link/styled-gatsby-link';
import MarketoForm from './marketo-form/marketo-form';
import Modal from './modal/modal';
import NavbarTop from './navbar-top/navbar-top';
import Navbar from './navbar/navbar';
import Paper from './paper/paper';
import Pingdom from './pingdom/pingdom';
import SEO from './seo/seo';
import Spacer from './spacer/spacer';
import Text from './text/text';
import ThemeProvider from './theme-provider/theme-provider';
import VideoPlayButton from './video-play-button/video-play-button';
import VideoPlayer from './video-player/video-player';
import WistiaEmbed from './wistia-embed/wistia-embed';
// FIXME: backwards compatibiliy
const NavbarContext = Navbar.Context;
const NavbarWrapper = Navbar.Wrapper;
const LucidContainer = Container;

export {
  Accordion,
  BounceDetection,
  Box,
  Breadcrumb,
  Button,
  Card,
  CarouselCard,
  CTACard,
  HeadingCard,
  TileCard,
  Collection,
  Container,
  LayoutContext,
  ABTestContext,
  Form,
  Heading,
  Icon,
  Image,
  Link,
  StyledGatsbyLink,
  linkParser,
  MarketoForm,
  LucidContainer,
  Modal,
  Navbar,
  NavbarTop,
  NavbarContext,
  NavbarWrapper,
  Paper,
  Pingdom,
  SEO,
  Spacer,
  Text,
  ThemeProvider,
  VideoPlayButton,
  VideoPlayer,
  WistiaEmbed
};

// types
export type LayoutContextProps = ILayoutContextProps;
export type ABTestContextPossibleTriggers = IABTestContextPossibleTriggers;
